import React, { useEffect } from 'react';
import {Dialog, DialogContent, DialogContentText, DialogTitle, Divider, IconButton} from '@mui/material';
import {Button, Card, Form, FormControl, Table} from "react-bootstrap";
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment'
import 'moment/locale/tr'
import {
    connectionErrorMessage,
    estimatedAhtapotUpdateFileCountDtoUrl,
    overFlowDosyaCountMessage,
    overFlowDosyaCountMessageId,
    saveAhtapotUpdateFileCountDtoUrl
} from "../data";
import {toast} from "react-toastify";
import {useCookies} from "react-cookie";
import WarningDialog from "../ui/dialog/WarningDialog";

function AhtapotUpdateFileCountFormDialog(props) {
    const selectedTenantSubscriptionViewDto = props.tenantSubscriptionViewDto;
    const [updateFileCountDto, setUpdateFileCountDto] = React.useState(props.ahtapotUpdateFileCountDto);
    const [cookies] = useCookies(['subscriptionToken']);
    const [updatedFileCount, setUpdatedFileCount] = React.useState(props.ahtapotUpdateFileCountDto?.updatedFileCount || 0);
    const [openWarningFormDialog, setOpenWarningFormDialog] = React.useState(false);

    useEffect(() => {
        setUpdateFileCountDto(props.ahtapotUpdateFileCountDto);
        setUpdatedFileCount(props.ahtapotUpdateFileCountDto?.updatedFileCount || 0);
    }, [props.ahtapotUpdateFileCountDto]);

    const handleCalculate = async (save = false) => {
        fetch(estimatedAhtapotUpdateFileCountDtoUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': `Bearer ${cookies.subscriptionToken}`
            },
            body: JSON.stringify({
                ...props.ahtapotUpdateFileCountDto,
                updatedFileCount: updatedFileCount
            })
        }).then(res => {
            if (res.ok) {
                return res.json();
            } else {
                return res.json().then(err => {
                    console.error("err : ", err)
                    throw new Error(err.message || connectionErrorMessage);
                });
            }
        }).then((data) => {
            if (data) {
                setUpdateFileCountDto(data);
                setUpdatedFileCount(data.updatedFileCount || 0);
                if(save){
                    if(updatedFileCount === props.ahtapotUpdateFileCountDto.fileCount) {
                        return;
                    }
                    setOpenWarningFormDialog(true);
                }
            }
        }, (error) => {
            if (error) {
                if("WARNING_FILE_COUNT_MAX_LIMIT" === error.message) {
                    toast.info(overFlowDosyaCountMessage, {
                        position: toast.POSITION.TOP_CENTER,
                        toastId: overFlowDosyaCountMessageId
                    });
                } else {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            } else {
                toast.error("Dosya Güncellemede Sorun Oluştu!", {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        });
    };

    const handleFileCountChange = (e) => {
        const value = Number(e.target.value);
        setUpdatedFileCount(value);
        setUpdateFileCountDto(prev => ({
            ...prev,
            updatedFileCount: value
        }));
    };

    const handleCloseWarningFormDialog = () => {
        setOpenWarningFormDialog(false);
    };

    const handleAcceptWarningFormDialog = () => {
        if(updatedFileCount === props.ahtapotUpdateFileCountDto.fileCount) {
            return;
        }
        fetch(saveAhtapotUpdateFileCountDtoUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': `Bearer ${cookies.subscriptionToken}`
            },
            body: JSON.stringify({
                ...props.ahtapotUpdateFileCountDto,
                updatedFileCount: updatedFileCount
            })
        }).then(res => {
            if (res.ok) {
                setOpenWarningFormDialog(false);
                props.handleCloseDialog();
                toast.success(<div className="center-text-toast"><p>Dosya sayısı ve abonelik süresi başarıyla güncellendi.</p>
                    <button>Tamam</button>
                </div>, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: false,
                    onClose: () => props?.refreshTab()
                });
            } else {
                return res.json().then(err => {
                    console.error("err : ", err)
                    toast.error(err.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                });
            }
        });
    }

    const confirmationMessage = (
        <span>
        Mevcut dosya sayınız{" "}
            <strong>{props.ahtapotUpdateFileCountDto.fileCount}</strong> ve kalan gün sayınız{" "}
            <strong>{props.ahtapotUpdateFileCountDto.expiryDayCount}</strong>{" "}
            iken dosya sayınız{" "}
            <strong
                style={{
                    color:
                        (updateFileCountDto?.fileChangeRate || 0) < 0
                            ? "red"
                            : (updateFileCountDto?.fileChangeRate || 0) > 0
                                ? "green"
                                : "black",
                }}
            >
            {`${updateFileCountDto?.fileChangeRate > 0 ? '+' : ''}${updateFileCountDto?.fileChangeRate?.toFixed(2) || '0.00'}%`}
        </strong>{" "}
            oranında değişerek, kalan gün sayınız{" "}
            <strong style={{
                color:
                    (updateFileCountDto?.fileChangeRate || 0) < 0
                        ? "red"
                        : (updateFileCountDto?.fileChangeRate || 0) > 0
                            ? "green"
                            : "black",
            }}>{updateFileCountDto.updatedDayCount}</strong> olarak güncellenecektir. Onaylıyor musunuz?
    </span>
    );

    const handleCloseDialog = () => {
        setUpdateFileCountDto(props.ahtapotUpdateFileCountDto);
        setUpdatedFileCount(props.ahtapotUpdateFileCountDto?.updatedFileCount || 0);
        props.handleCloseDialog();
    };
    const handleResetForm = () => {
        setUpdateFileCountDto(props.ahtapotUpdateFileCountDto);
        setUpdatedFileCount(props.ahtapotUpdateFileCountDto?.updatedFileCount || 0);
    };

    return (
        <Dialog
            open={props.openDialog}
            onClose={props.handleCloseDialog}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle>
                <h1>{}</h1>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div>
                        <p style={{
                            verticalAlign: 'middle',
                            float: 'left',
                            fontSize: 30,
                            margin: 0,
                            padding: 0,
                            color: props.color
                        }}>{props.title}
                        </p>
                        {selectedTenantSubscriptionViewDto ? <p>{selectedTenantSubscriptionViewDto.tenantName}</p> : null}
                    </div>
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseDialog}
                        sx={{
                            position: 'absolute',
                            right: 2,
                            top: 2,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Card>
                        <Card.Body className="font-weight-bold p-2">
                            <Table striped bordered hover responsive size="sm">
                                <tbody>
                                <tr>
                                    <td>
                                        <Form.Label className="pl-1">
                                            Abonelik Başlangıç Tarihi
                                        </Form.Label>
                                    </td>
                                    <td className="text-right align-middle">
                                        <FormControl
                                            type="datetime"
                                            disabled
                                            className="pl-4 text-center"
                                            value={moment(updateFileCountDto?.validIntervalBeginDateTime).locale('tr').format("LL")}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label className="pl-1">
                                            Abonelik Bitiş Tarihi
                                        </Form.Label>
                                    </td>
                                    <td className="text-center align-middle">
                                        <FormControl
                                            type="datetime"
                                            disabled
                                            className="pl-4 text-center"
                                            value={moment(updateFileCountDto.updatedDayCount > 0 ? updateFileCountDto.updatedEndDateTime :
                                                updateFileCountDto?.validIntervalEndDateTime).locale('tr').format("LL")}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label className="pl-1">
                                            Kalan Gün Sayısı
                                        </Form.Label>
                                    </td>
                                    <td className="text-center align-middle">
                                        <FormControl
                                            type="number"
                                            disabled
                                            value={updateFileCountDto.updatedDayCount > 0 ? updateFileCountDto.updatedDayCount : updateFileCountDto?.expiryDayCount || 0}
                                            className="pl-4 text-center"
                                        />
                                    </td>
                                </tr>
                                <Divider/><br/><Divider/>
                                <tr>
                                    <td>
                                        <Form.Label className="pl-1">
                                            Dosya Sayısı
                                        </Form.Label>
                                    </td>
                                    <td className="text-center align-middle">
                                        <FormControl
                                            type="number"
                                            disabled
                                            className="pl-4 text-center"
                                            value={updateFileCountDto?.fileCount || 0}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label className="pl-1">
                                            Güncellenmek İstenen Dosya Sayısı
                                        </Form.Label>
                                    </td>
                                    <td className="text-center align-middle">
                                        <FormControl
                                            type="number"
                                            className="pl-4 text-center"
                                            value={updatedFileCount}
                                            onChange={handleFileCountChange}
                                            style={{ textAlign: 'right' }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label className="pl-1">
                                            Dosya Değişim Oranı
                                        </Form.Label>
                                    </td>
                                    <td className="text-center align-middle">
                                        <FormControl
                                            type="text"
                                            disabled
                                            className={`pl-4 text-center font-weight-bold ${
                                                (updateFileCountDto?.fileChangeRate || 0) < 0
                                                    ? "text-danger font-weight-bolder"
                                                    : (updateFileCountDto?.fileChangeRate || 0) > 0
                                                        ? "text-success font-weight-bolder"
                                                        : "text-dark"
                                            }`}
                                            value={`${(updateFileCountDto?.fileChangeRate || 0) > 0 ? '+' : ''}${(updateFileCountDto?.fileChangeRate || 0).toFixed(2)}%`}
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </Table>
                        </Card.Body>
                        <div style={{display: 'flex', justifyContent: 'space-between', padding: '1px 5px 5px'}}>
                            <Button onClick={() => handleCalculate(false)} variant="info">
                                Güncel Durumu Hesapla
                            </Button>
                            <div style={{display: 'flex', gap: '8px'}}>
                                <Button
                                    onClick={handleResetForm}
                                    variant="secondary"
                                >
                                    Temizle
                                </Button>
                                <Button onClick={() => handleCalculate(true)} variant="primary">
                                    Kaydet
                                </Button>
                            </div>
                        </div>
                    </Card>
                </DialogContentText>
                <>
                    <div style={{padding: 0, margin: 0, color: "#e80000", fontWeight: "bold", fontSize: "0.7rem"}}>
                        ** Güncellenecek dosya sayınız 500 adedin altına düşürülememektedir!
                    </div>
                    <div style={{padding: 0, margin: 0, color: "#e80000", fontWeight: "bold", fontSize: "0.7rem"}}>
                    ** Abonelik sürenizin bitmesine 3 günden az zaman kaldığı için abonelik güncelleme işlemi yapılamamaktadır!
                    </div>
                </>
            </DialogContent>
            <WarningDialog
                openDialog={openWarningFormDialog}
                handleAcceptDialog={handleAcceptWarningFormDialog}
                handleCloseDialog={handleCloseWarningFormDialog}
                color={'red'}
                title={"Onay"}
                dialogContentText={confirmationMessage}
            />
        </Dialog>
    );
}

export default AhtapotUpdateFileCountFormDialog;